import axios, { type InternalAxiosRequestConfig } from 'axios';

interface HttpError {
  message: string;
  statusCode: number;
  errors?: Record<string, string[]>;
}

const CREDENTIALS_KEY = 'woolaby_admin_credentials';

const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL || undefined,
});

axiosInstance.interceptors.request.use(
  (config: InternalAxiosRequestConfig): InternalAxiosRequestConfig => {
    const credentials = localStorage.getItem(CREDENTIALS_KEY);

    if (credentials && config.headers) {
      config.headers.Authorization = `Basic ${credentials}`;
    }

    return config;
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const httpError: HttpError = {
      message:
        error.response?.data?.error ||
        error.response?.data?.message ||
        error.message ||
        'An error occurred',
      statusCode: error.response?.status || 500,
    };

    return Promise.reject(httpError);
  }
);

export { axiosInstance, CREDENTIALS_KEY };
export type { HttpError };
